import { CreditCollectionComponent } from './component/credit-collection/credit-collection.component';
import { ConsolidatedPhoneReportComponent } from './component/consolidated-phone-report/consolidated-phone-report.component';
import { IntercompanyAdjustmentComponent } from './component/intercompany-adjustment/intercompany-adjustment.component';
import { ConsolidatedWalletComponent } from './component/consolidated-wallet/consolidated-wallet.component';
import { RiskReviewComponent } from './component/risk-review/risk-review.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { NotLoginGuard } from './guard/not-login.guard';
import { IsLoginGuard } from './guard/is-login.guard';

import { LayoutPreComponent } from './layout/layout-pre/layout-pre.component';
import { LayoutPostComponent } from './layout/layout-post/layout-post.component';
import { DashboardComponent } from './component/dashboard/dashboard.component';
import { ConsolidatedDashboardComponent } from './component/consolidated-dashboard/consolidated-dashboard.component';
import { ConsolidatedDailySalesReportComponent } from './component/consolidated-daily-sales-report/consolidated-daily-sales-report.component';
import { ConsolidatedSummaryReportComponent } from './component/consolidated-summary-report/consolidated-summary-report.component';
import { LoginComponent } from './component/login/login.component';
import { PageNotFoundComponent } from './component/page-not-found/page-not-found.component';
import { AdminManagementComponent } from './component/admin-management/admin-management.component';
import { AdminCompanyComponent } from './component/admin-company/admin-company.component';
import { AdminCompanyFormComponent } from './component/admin-company-form/admin-company-form.component';
import { AdminUserComponent } from './component/admin-user/admin-user.component';
import { AdminUserFormComponent } from './component/admin-user-form/admin-user-form.component';
import { SettingGameComponent } from './component/setting-game/setting-game.component';
import { SettingBankComponent } from './component/setting-bank/setting-bank.component';
import { SettingIntegrationComponent } from './component/setting-integration/setting-integration.component';
import { SettingGameFormComponent } from './component/setting-game-form/setting-game-form.component';
import { SettingBankFormComponent } from './component/setting-bank-form/setting-bank-form.component';
import { SettingIntegrateFormComponent } from './component/setting-integrate-form/setting-integrate-form.component';
import { SettingAdjustmentComponent } from './component/setting-adjustment/setting-adjustment.component';
import { UnknownPaymentComponent } from './component/unknown-payment/unknown-payment.component';
import { UnknownPaymentClaimComponent } from './component/unknown-payment-claim/unknown-payment-claim.component';
import { UnknownPaymentFormComponent } from './component/unknown-payment-form/unknown-payment-form.component';
import { PlayerComponent } from './component/player/player.component';
import { SearchPlayerComponent } from './component/search-player/search-player.component';
import { PlayerFormComponent } from './component/player-form/player-form.component';
import { TopupWithdrawComponent } from './component/topup-withdraw/topup-withdraw.component';
import { TopupWithdrawFormComponent } from './component/topup-withdraw-form/topup-withdraw-form.component';

import { WinloseComponent } from './component/winlose/winlose.component';
import { ResetPasswordComponent } from './component/reset-password/reset-password.component';
import { CompanyResolverResolver } from './company-resolver.resolver';
import { UnauthorizedComponent } from './component/unauthorized/unauthorized.component';
import { ChatComponent } from './component/chat/chat.component';
import { FrontActionComponent } from './component/front-action/front-action.component';

import { FrontPromotionComponent } from './component/front-promotion/front-promotion.component';
import { FrontBannerComponent } from './component/front-banner/front-banner.component';
import { FrontCategoryComponent } from './component/front-category/front-category.component';
import { FrontGamesComponent } from './component/front-games/front-games.component';
import { FrontOtherComponent } from './component/front-other/front-other.component';
import { FrontSettingComponent } from './component/front-setting/front-setting.component';

import { FrontPromotionFormComponent } from './component/front-promotion-form/front-promotion-form.component';
import { FrontBannerFormComponent } from './component/front-banner-form/front-banner-form.component';
import { FrontCategoryFormComponent } from './component/front-category-form/front-category-form.component';
import { FrontGamesFormComponent } from './component/front-games-form/front-games-form.component';

import { FrontPageFormComponent } from './component/front-page-form/front-page-form.component';
import { FrontPageComponent } from './component/front-page/front-page.component';
import { FrontHookFormComponent } from './component/front-hook-form/front-hook-form.component';
import { FrontHookComponent } from './component/front-hook/front-hook.component';
import { BankReportComponent } from './component/bank-report/bank-report.component';

import { InstantNotificationComponent } from './component/instant-notification/instant-notification.component';
import { InstantNotificationFormComponent } from './component/instant-notification-form/instant-notification-form.component';

import { AgentManagementComponent } from './component/agent-management/agent-management.component';
import { AgentCreditManagementComponent } from './component/agent-credit-management/agent-credit-management.component';
import { PlayerDailyComponent } from './component/player-daily/player-daily.component';
import { AdminReportComponent } from './component/admin-report/admin-report.component';
import { VoucherComponent } from './component/voucher/voucher.component';
import { VoucherFormComponent } from './component/voucher-form/voucher-form.component';
import { MassVoucherGeneratorComponent } from './component/mass-voucher-generator/mass-voucher-generator.component';
import { VoucherUsageRandomComponent } from './component/voucher-usage-random/voucher-usage-random.component';
import { DrawSectionsComponent } from './component/draw-sections/draw-sections.component';
import { DrawSectionFormComponent } from './component/draw-sections/draw-section-form/draw-section-form.component';
import { CallReportComponent } from './component/call-report/call-report.component';
import { AccountComponent } from './component/account/account.component';
import { AccountFormComponent } from './component/account-form/account-form.component';
import { SummaryReportComponent } from './component/summary-report/summary-report.component';
import { CompanySettingComponent } from './component/company-setting/company-setting.component';
import { AutoTopupWithdrawComponent } from './component/auto-topup-withdraw/auto-topup-withdraw.component';

import { WeeklyAccountComponent } from './component/weekly-account/weekly-account.component';
import { DailySalesReportComponent } from './component/daily-sales-report/daily-sales-report.component';
import { IntegrationReportComponent } from './component/integration-report/integration-report.component';
import { AgentReportPlayerDetailComponent } from './component/agent-report-player-detail/agent-report-player-detail.component';
import { SaIntegrationComponent } from './component/sa-integration/sa-integration.component';
import { AdjustmentComponent } from './component/adjustment/adjustment.component';

import { IsMarioGuard } from './guard/is-mario.guard';
import { SettingIntegrationFormComponent } from './component/setting-integration-form/setting-integration-form.component';

import { ManualTopupWithdrawComponent } from './component/manual-topup-withdraw/manual-topup-withdraw.component';
import { WhatsappComponent } from './component/whatsapp/whatsapp.component';
import { ChatChannelListComponent } from './component/chat-channel-list/chat-channel-list.component';
import { MultichatServerComponent } from './component/multichat-server/multichat-server.component';
import { WebChatSettingsComponent } from './component/web-chat-settings/web-chat-settings.component';
import { WalletTopupWithdrawComponent } from './component/wallet-topup-withdraw/wallet-topup-withdraw.component';
import { ApiGameManagementFormComponent } from './component/api-game-management-form/api-game-management-form.component';
import { ApiGameManagementComponent } from './component/api-game-management/api-game-management.component';
import { WwWalletComponent } from './component/ww-wallet/ww-wallet.component';
import { GameLogComponent } from './component/game-log/game-log.component';
import { FourdkingBetHistoryComponent } from './component/fourdking-bet-history/fourdking-bet-history.component';
import { PromotionCategoryComponent } from './component/promotion-category/promotion-category.component';
import { PromotionCategoryFormComponent } from './component/promotion-category-form/promotion-category-form.component';
import { SettingRollingComponent } from './component/setting-rolling/setting-rolling.component';
import { SettingRollingFormComponent } from './component/setting-rolling-form/setting-rolling-form.component';
import { LayoutDocumentComponent } from './layout/layout-document/layout-document.component';
import { SettingPlayerLevelComponent } from './component/setting-player-level/setting-player-level.component';
import { SettingPlayerLevelFormComponent } from './component/setting-player-level-form/setting-player-level-form.component';
import { DepositComponent } from './component/deposit/deposit.component';
import { SmsListComponent } from './component/sms-list/sms-list.component';
import { TransferGameComponent } from './component/transfer-game/transfer-game.component';
import { TransferGameFormComponent } from './component/transfer-game-form/transfer-game-form.component';
import { TemplateListComponent } from './component/template-list/template-list.component';
import { PlayerListComponent } from './component/player-list/player-list.component';
import { SmsLogComponent } from './component/sms-log/sms-log.component';
import { SettingUserComponent } from './component/setting-user/setting-user.component';
import { SettingCompanyComponent } from './component/setting-company/setting-company.component';
import { SettingUserFormComponent } from './component/setting-user-form/setting-user-form.component';
import { SummaryReportV2Component } from './component/summary-report-v2/summary-report-v2.component';
import { HotGameManagementFormComponent } from './component/hot-game-management-form/hot-game-management-form.component';
import { HotGameManagementComponent } from './component/hot-game-management/hot-game-management.component';
import { AutomatedComponent } from './component/automated/automated.component';
import { AutomatedFormComponent } from './component/automated-form/automated-form.component';
import { AgentReportComponent } from './component/agent-report/agent-report.component';
import { AgentAccountComponent } from './component/agent-account/agent-account.component';
import { AgentAccountDetailComponent } from './component/agent-account/agent-account-detail.component';
import { AgentCommissionOverviewComponent } from './component/agent-commission-overview/agent-commission-overview.component';
import { LineWinlossComponent } from './component/line-winloss/line-winloss.component';
import { BankerGroupComponent } from './component/banker-group/banker-group.component';
import { BankerGroupFormComponent } from './component/banker-group-form/banker-group-form.component';
import { BankerGroupDetailComponent } from './component/banker-group-detail/banker-group-detail.component';
import { PromotionLogComponent } from './component/promotion-log/promotion-log.component';
import { PaymentGatewayLogComponent } from './component/payment-gateway-log/payment-gateway-log.component';
import { TopupPointLogComponent } from './component/topup-point-log/topup-point-log.component';
import { PlayerCreditComponent } from './component/player-credit/player-credit.component';
import { PlayerCreditReportComponent } from './component/player-credit-report/player-credit-report.component';
import { SettingPaymentGatewayComponent } from './component/setting-payment-gateway/setting-payment-gateway.component';
import { SettingPaymentGatewayFormComponent } from './component/setting-payment-gateway-form/setting-payment-gateway-form.component';
import { NotificationComponent } from './component/notification/notification.component';
import { WithdrawComponent } from './component/withdraw/withdraw.component';
import { AgentWithdrawComponent } from './component/agent-withdraw/agent-withdraw.component';
import { AgentLevelPurchaseComponent } from './component/agent-level-purchase/agent-level-purchase.component';
import { ExportComponent } from './component/export/export.component';
import { DomainManagementComponent } from './component/domain-management/domain-management.component';
import { DomainManagementFormComponent } from './component/domain-management-form/domain-management-form.component';
import { DomainSetupComponent } from './component/domain-setup/domain-setup.component';
import { ManageSupplierGameComponent } from './component/manage-supplier-game/manage-supplier-game.component';
import { SeoSettingComponent } from './component/seo-setting/seo-setting.component';
import { FrontPartnershipComponent } from './component/front-partnership/front-partnership.component';
import { FrontPartnershipFormComponent } from './component/front-partnership-form/front-partnership-form.component';
const routes: Routes = [
  {
    path: 'lr',
    component: LayoutPreComponent,
    canActivate: [NotLoginGuard],
    children: [
      {
        path: '',
        component: LoginComponent,
      },
      {
        path: 'page-not-found',
        component: PageNotFoundComponent
      },
      {
        path: '**',
        component: PageNotFoundComponent
      }
    ],
  },
  {
    path: 'lo/admin',
    component: LayoutPostComponent,
    canActivate: [IsLoginGuard],
    resolve: { message: CompanyResolverResolver },
    children: [

      {
        path: 'company/user/:company_uuid',
        component: AdminCompanyFormComponent,
      },
      {
        path: 'user/form/:company_uuid/:user_uuid',
        component: AdminUserFormComponent,
      },
      {
        path: 'user/permission/:user_company_uuid',
        component: AdminManagementComponent,
      },
      {
        path: 'user/form/:company_uuid',
        component: AdminUserFormComponent,
      },
      {
        path: 'user/form',
        component: AdminUserFormComponent,
      },
      {
        path: 'user',
        component: AdminUserComponent,
      },
      {
        path: 'company/form',
        component: AdminCompanyFormComponent,
      },
      {
        path: 'company/form/:company_uuid',
        component: AdminCompanyFormComponent,
      },
      {
        path: "sa-integration",
        canActivate: [IsMarioGuard],
        component: SaIntegrationComponent
      },
      {
        path: 'company',
        component: AdminCompanyComponent,
      },
      {
        path: '**',
        component: PageNotFoundComponent
      }
    ],
  },
  {
    path: 'lo',
    component: LayoutPostComponent,
    canActivate: [IsLoginGuard],
    resolve: { message: CompanyResolverResolver },
    children: [
      {
        path: '',
        component: UnauthorizedComponent,
      },
      {
        path: 'reset-password',
        component: ResetPasswordComponent,
      },
    ],
  },
  {
    path: 'lo/:company_uuid',
    component: LayoutPostComponent,
    canActivate: [IsLoginGuard],
    resolve: { message: CompanyResolverResolver },
    children: [
      { path: 'risk-review', component: RiskReviewComponent },
      {
        path: 'dashboard',
        component: DashboardComponent,
      },
      {
        path: 'intercompany-adjustment',
        component: IntercompanyAdjustmentComponent,
      },
      {
        path: 'consolidated-phone-report', component: ConsolidatedPhoneReportComponent,
      },
      {
        path: 'consolidated-wallet',
        component: ConsolidatedWalletComponent,
      },
      {
        path: 'consolidated-dashboard',
        component: ConsolidatedDashboardComponent,
      },
      {
        path: 'consolidated-daily-sales-report',
        component: ConsolidatedDailySalesReportComponent,
      },
      {
        path: 'consolidated-summary-report',
        component: ConsolidatedSummaryReportComponent,
      },
      {
        path: 'notification',
        component: NotificationComponent
      },
      {
        path: 'bank/report/:bank_uuid',
        component: BankReportComponent,
      },
      {
        path: 'winlose/:type',
        component: WinloseComponent
      },
      {
        path: 'deposit',
        component: DepositComponent
      },
      {
        path: 'withdraw',
        component: WithdrawComponent
      },
      {
        path: 'agent-withdraw',
        component: AgentWithdrawComponent
      },
      {
        path: 'agent-level-purchase',
        component: AgentLevelPurchaseComponent
      },
      {
        path: 'sms',
        component: SmsListComponent
      },
      {
        path: 'agent-report',
        component: IntegrationReportComponent
      },
      {
        path: 'agent-report/player-detail',
        component: AgentReportPlayerDetailComponent
      },
      {
        path: 'agent-report-v2',
        component: AgentReportComponent
      },
      {
        path: 'agent-commission-overview',
        component: AgentCommissionOverviewComponent
      },
      {
        path: 'referral-rolling-account',
        component: AgentAccountComponent
      },
      {
        path: 'referral-rolling-account/:agent_code',
        component: AgentAccountDetailComponent
      },
      {
        path: 'agent-line-winloss',
        component: LineWinlossComponent
      },
      {
        path: 'agent-line-winloss/:agent_code',
        component: LineWinlossComponent
      },
      {
        path: 'call-report',
        component: CallReportComponent
      },
      {
        path: 'call-report/:call_report_uuid',
        component: CallReportComponent
      },
      {
        path: 'admin/report/:type',
        component: AdminReportComponent
      },
      {
        path: 'setting-game',
        component: SettingGameComponent
      },
      {
        path: 'setting-game/form',
        component: SettingGameFormComponent
      },
      {
        path: 'setting-game/form/:uuid',
        component: SettingGameFormComponent
      },
      {
        path: 'transfer-game-setting',
        component: TransferGameComponent
      },
      {
        path: 'transfer-game-setting/form',
        component: TransferGameFormComponent
      },
      {
        path: 'transfer-game-setting/form/:uuid',
        component: TransferGameFormComponent
      },
      {
        path: 'api-game-setting',
        component: ApiGameManagementComponent
      },
      {
        path: 'api-game-setting/form',
        component: ApiGameManagementFormComponent
      },
      {
        path: 'api-game-setting/form/:uuid',
        component: ApiGameManagementFormComponent
      },
      {
        path: 'setting-rolling',
        component: SettingRollingComponent
      },
      {
        path: 'setting-rolling/form',
        component: SettingRollingFormComponent
      },
      {
        path: 'setting-rolling/form/:uuid',
        component: SettingRollingFormComponent
      },
      {
        path: 'ww-wallet',
        component: WwWalletComponent
      },
      {
        path: 'setting-voucher',
        component: VoucherComponent
      },
      {
        path: 'setting-bank',
        component: SettingBankComponent
      },
      {
        path: 'setting-bank/form',
        component: SettingBankFormComponent
      },
      {
        path: 'setting-bank/form/:uuid',
        component: SettingBankFormComponent
      },
      {
        path: 'chat-template',
        component: TemplateListComponent
      },
      {
        path: 'chat-template/:template_uuid',
        component: TemplateListComponent
      },
      {
        path: 'game-log',
        component: GameLogComponent
      },
      {
        path: 'fourdking-bet-history',
        component: FourdkingBetHistoryComponent
      },
      {
        path: 'promotion-log',
        component: PromotionLogComponent
      },
      {
        path: 'payment-gateway-log',
        component: PaymentGatewayLogComponent
      },
      {
        path: 'topup-point-log',
        component: TopupPointLogComponent
      },
      {
        path: 'player-credit',
        component: PlayerCreditComponent
      },
      {
        path: 'credit-collection',
        component: CreditCollectionComponent
      },
      {
        path: 'player-credit-report',
        component: PlayerCreditReportComponent
      },
      {
        path: 'setting-payment-gateway',
        component: SettingPaymentGatewayComponent
      },
      {
        path: 'setting-payment-gateway/form',
        component: SettingPaymentGatewayFormComponent
      },
      {
        path: 'setting-payment-gateway/form/:uuid',
        component: SettingPaymentGatewayFormComponent
      },
      {
        path: 'voucher/form/:uuid',
        component: VoucherFormComponent
      },
      {
        path: 'voucher/form',
        component: VoucherFormComponent
      },
      {
        path: 'draw-section/form/:uuid',
        component: DrawSectionFormComponent
      },
      {
        path: 'draw-section/form',
        component: DrawSectionFormComponent
      },
      {
        path: 'draw-section',
        component: DrawSectionsComponent
      },
      {
        path: 'mass-voucher-generator',
        component: MassVoucherGeneratorComponent
      },
      {
        path: 'voucher-usage',
        component: VoucherUsageRandomComponent
      },
      {
        path: 'setting-integration',
        component: SettingIntegrationComponent
      },
      {
        path: 'setting-integration/form',
        component: SettingIntegrationFormComponent
      },
      {
        path: 'setting-integration/form/:uuid',
        component: SettingIntegrationFormComponent
      },
      {
        path: 'setting-notification',
        component: InstantNotificationComponent
      },
      {
        path: 'setting-notification/form',
        component: InstantNotificationFormComponent
      },
      {
        path: 'setting-notification/form/:uuid',
        component: InstantNotificationFormComponent
      },
      {
        path: 'player-list',
        component: PlayerListComponent
      },
      {
        path: 'export-data',
        component: ExportComponent
      },
      {
        path: 'adjustment',
        component: AdjustmentComponent
      },
      {
        path: 'setting-adjustment',
        component: SettingAdjustmentComponent
      },
      {
        path: 'setting-adjustment/:type',
        component: SettingAdjustmentComponent
      },
      {
        path: 'setting-player-level',
        component: SettingPlayerLevelComponent
      },
      {
        path: 'setting-player-level/form',
        component: SettingPlayerLevelFormComponent
      },
      {
        path: 'setting-player-level/form/:uuid',
        component: SettingPlayerLevelFormComponent
      },
      {
        path: 'setting-agent',
        component: AgentManagementComponent
      },
      {
        path: 'agent/rate/:agent_uuid',
        component: AgentCreditManagementComponent
      },
      {
        path: 'unknown-payment',
        component: UnknownPaymentComponent
      },
      {
        path: 'unknown-payment/claim/:transaction_id',
        component: UnknownPaymentClaimComponent
      },
      {
        path: 'unknown-payment/form',
        component: UnknownPaymentFormComponent
      },
      {
        path: 'unknown-payment/form/:uuid',
        component: UnknownPaymentFormComponent
      },
      {
        path: 'chat',
        component: ChatComponent
      },
      {
        path: 'chat/:chat_uuid',
        component: ChatComponent
      },
      {
        path: "sms-log",
        component: SmsLogComponent
      },
      {
        path: 'front/management',
        component: FrontActionComponent
      },
      {
        path: 'front/promotion',
        component: FrontPromotionComponent
      },
      {
        path: 'front/promotion/form',
        component: FrontPromotionFormComponent
      },
      {
        path: 'front/promotion/form/:promotion_uuid',
        component: FrontPromotionFormComponent
      },
      {
        path: 'front/promotion-category',
        component: PromotionCategoryComponent
      },
      {
        path: 'front/promotion-category/form',
        component: PromotionCategoryFormComponent
      },
      {
        path: 'front/promotion-category/form/:promotion_category_uuid',
        component: PromotionCategoryFormComponent
      },
      {
        path: 'front/banner',
        component: FrontBannerComponent
      },
      {
        path: 'front/banner/form',
        component: FrontBannerFormComponent
      },
      {
        path: 'front/banner/form/:banner_uuid',
        component: FrontBannerFormComponent
      },
      {
        path: 'front/category',
        component: FrontCategoryComponent
      },
      {
        path: 'front/category/form',
        component: FrontCategoryFormComponent
      },
      {
        path: 'front/category/form/:category_uuid',
        component: FrontCategoryFormComponent
      },
      {
        path: 'front/games',
        component: FrontGamesComponent
      },
      {
        path: 'front/games/form',
        component: FrontGamesFormComponent
      },
      {
        path: 'front/games/form/:game_view_uuid',
        component: FrontGamesFormComponent
      },
      {
        path: 'domain-management',
        component: DomainManagementComponent
      },
      {
        path: 'domain-management/form',
        component: DomainManagementFormComponent
      },
      {
        path: 'domain-management/form/:domain_uuid',
        component: DomainManagementFormComponent
      },
      {
        path: 'domain-management/setup/:domain_uuid',
        component: DomainSetupComponent
      },
      {
        path: 'setting-supplier-game',
        component: ManageSupplierGameComponent
      },
      // {
      //   path: 'front/promotion',
      //   component: PromotionComponent
      // },
      // {
      //   path: 'front/promotion/form',
      //   component: PromotionFormComponent
      // },
      // {
      //   path: 'front/promotion/form/:promotion_uuid',
      //   component: PromotionFormComponent
      // },
      {
        path: 'front/page',
        component: FrontPageComponent
      },
      {
        path: 'front/page/form',
        component: FrontPageFormComponent
      },
      {
        path: 'front/page/form/:page_uuid',
        component: FrontPageFormComponent
      },
      {
        path: 'front/hook',
        component: FrontHookComponent
      },
      {
        path: 'front/hook/form',
        component: FrontHookFormComponent
      },
      {
        path: 'front/hook/form/:banner_uuid',
        component: FrontHookFormComponent
      },
      {
        path: 'front/other',
        component: FrontOtherComponent
      },
      {
        path: 'front/setting/:tab',
        component: FrontSettingComponent
      },
      {
        path: 'front/setting',
        component: FrontSettingComponent
      },
      {
        path: 'front/seo-setting',
        component: SeoSettingComponent
      },
      {
        path: 'front/partnership',
        component: FrontPartnershipComponent
      },
      {
        path: 'front/partnership/form',
        component: FrontPartnershipFormComponent
      },
      {
        path: 'front/partnership/form/:partnership_uuid',
        component: FrontPartnershipFormComponent
      },
      {
        path: 'partnership',
        component: FrontPartnershipComponent
      },
      {
        path: 'partnership/report',
        component: FrontPartnershipComponent
      },
      {
        path: 'partnership/form',
        component: FrontPartnershipFormComponent
      },
      {
        path: 'partnership/form/:partnership_uuid',
        component: FrontPartnershipFormComponent
      },
      {
        path: 'player',
        component: SearchPlayerComponent
      },
      {
        path: 'player/form',
        component: PlayerFormComponent
      },
      {
        path: 'player/daily/:uuid',
        component: PlayerDailyComponent
      },
      {
        path: 'player-list',
        component: PlayerComponent
      },
      {
        path: 'player/form/:uuid',
        component: PlayerFormComponent
      },
      {
        path: 'topup-withdraw',
        component: TopupWithdrawComponent
      },
      {
        path: 'topup-withdraw/form/:uuid',
        component: TopupWithdrawFormComponent
      },
      {
        path: 'auto-topup-withdraw',
        component: AutoTopupWithdrawComponent
      },
      {
        path: 'manual-topup-withdraw',
        component: ManualTopupWithdrawComponent
      },
      {
        path: 'wallet-topup-withdraw',
        component: WalletTopupWithdrawComponent
      },
      {
        path: 'weekly-account',
        component: WeeklyAccountComponent
      },
      {
        path: 'daily-sales-report',
        component: DailySalesReportComponent
      },
      {
        path: 'summary-report',
        component: SummaryReportComponent
      },
      {
        path: 'summary-report-v2',
        component: SummaryReportV2Component
      },
      {
        path: 'setting-hot-game',
        component: HotGameManagementComponent
      },
      {
        path: 'setting-hot-game/form',
        component: HotGameManagementFormComponent
      },
      {
        path: 'setting-hot-game/form/:uuid',
        component: HotGameManagementFormComponent
      },
      {
        path: "setting-automated",
        component: AutomatedComponent
      },
      {
        path: 'setting-automated/form',
        component: AutomatedFormComponent
      },
      {
        path: 'setting-automated/form/:uuid',
        component: AutomatedFormComponent
      },
      {
        path: 'company-setting',
        component: CompanySettingComponent
      },
      {
        path: 'account-management',
        component: AccountComponent
      },
      {
        path: 'account/form/:uuid',
        component: AccountFormComponent
      },
      {
        path: 'whatsapp',
        component: WhatsappComponent
      },
      {
        path: 'chat-channel',
        component: ChatChannelListComponent
      },
      {
        path: 'web-chat-settings',
        component: WebChatSettingsComponent
      },
      {
        path: 'multichat-server',
        component: MultichatServerComponent
      },
      {
        path: "user",
        component: SettingUserComponent
      },
      {
        path: "user/form/:user_uuid",
        component: SettingUserFormComponent
      },
      {
        path: "company",
        component: SettingCompanyComponent
      },
      {
        path: "banker-group-management",
        component: BankerGroupComponent
      },
      {
        path: "banker-group-management/form",
        component: BankerGroupFormComponent
      },
      {
        path: "banker-group-management/form/:uuid",
        component: BankerGroupFormComponent
      },
      {
        path: "banker-group-detail/:uuid",
        component: BankerGroupDetailComponent
      },
      {
        path: 'unauthorized',
        component: UnauthorizedComponent
      },
      {
        path: 'page-not-found',
        component: PageNotFoundComponent
      },
      {
        path: '**',
        component: PageNotFoundComponent
      }
    ],
  },
  { path: "document/:document_uuid", component: LayoutDocumentComponent, canActivate: [IsLoginGuard] },
  { path: "document", component: LayoutDocumentComponent, canActivate: [IsLoginGuard] },
  { path: '', redirectTo: '/lr', pathMatch: 'full' },
  { path: '', redirectTo: '/lr/page-not-found', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
